<template>
  <div>
    <!-- Modal backdrop -->
    <div
      v-if="showViewModal"
      class="fixed inset-0 z-50 flex items-center justify-center overflow-x-hidden overflow-y-auto outline-none focus:outline-none"
    >
      <div class="relative w-full h-full">
        <div class="relative w-full h-full bg-black rounded">
          <!-- Modal header -->
          <div class="flex items-center justify-between px-2 py-4">
            <button
              type="button"
              class="absolute right-0 flex items-center justify-center p-1 ml-auto text-sm font-thin text-white bg-transparent bg-gray-200 rounded-full w-14 hover:text-white"
              @click="closePhotoModal()"
              data-modal-toggle="show-login-modal"
            >
              <svg
                aria-hidden="true"
                class="w-5 h-5"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                  clip-rule="evenodd"
                ></path>
              </svg>
              <span class="sr-only">Close modal</span>
            </button>
          </div>
          <!-- Modal body with large image preview and image slider -->
          <div class="flex flex-col items-center justify-center h-full p-5">
            <!-- Large image preview -->
            <div class="w-[70rem] h-auto">
              <img
                :src="selectedImage"
                class="w-full md:h-[34rem] h-[30rem]"
                alt=""
              />
            </div>
            <!-- Image slider -->
            <div class="w-full h-full mt-5">
              <swiper
                :slides-per-view="10"
                :space-between="2"
                @swiper="onSwiper"
                @slideChange="onSlideChange"
              >
                <swiper-slide v-for="(photo, index) in photos" :key="index">
                  <img
                    :src="photo"
                    class="md:w-[5rem] md:h-[5rem] h-[3rem] w-[3rem] cursor-pointer"
                    alt="Thumbnail"
                    @click="showSelectedImage(photo)"
                  />
                </swiper-slide>
              </swiper>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal backdrop -->
    <div
      v-if="showViewModal"
      class="fixed inset-0 z-40 bg-black opacity-25"
    ></div>
  </div>
</template>

<script setup>
import { defineProps, getCurrentInstance, watch, ref } from "vue";
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";

const props = defineProps({
  showViewModal: Boolean,
  photos: Array,
});

const { emit } = getCurrentInstance();
const selectedImage = ref(props.photos[0]);

const closePhotoModal = () => {
  emit("closePhotoModal");
};

const onSwiper = (swiper) => {
  console.log(swiper);
};

const onSlideChange = () => {
  console.log("slide change");
};

// Function to update the selected image preview
const showSelectedImage = (image) => {
  selectedImage.value = image;
};

watch(
  () => props.showViewModal,
  (newVal) => {
    if (newVal) {
      console.log("Modal opened");
    }
  }
);
</script>

<style scoped>
.swiper-container {
  position: relative;
  bottom: 0;
  width: 100%;
}

.swiper-slide {
  margin-right: 10px;
}

.relative img {
  z-index: 1;
}
</style>
